import { Card, Col, Container, Row } from "react-bootstrap";
import { FaUsers, FaHandHoldingHeart, FaChartLine, FaPiggyBank } from "react-icons/fa";

function Features() {
  const features = [
    {
      id: 1,
      icon: <FaUsers size={30} color="var(--secondary-color)" />,
      title: "Crowdfunding",
      details:
        "Empower creators and entrepreneurs through transparent project funding with community support.",
    },
    {
      id: 2,
      icon: <FaHandHoldingHeart size={30} color="var(--secondary-color)" />,
      title: "Social Funding",
      details:
        "Support causes, communities, and charities with verified campaigns that create real impact.",
    },
    {
      id: 3,
      icon: <FaChartLine size={30} color="var(--secondary-color)" />,
      title: "Investments",
      details:
        "Access curated, high-ROI investment opportunities across various industries and sectors.",
    },
    {
      id: 4,
      icon: <FaPiggyBank size={30} color="var(--secondary-color)" />,
      title: "Savings",
      details:
        "Build wealth with flexible, high-yield saving plans tailored to your financial goals.",
    },
  ];

  return (
    <div id="features" className="section-padding bg-white">
      <Container>
        <div className="text-center mb-5">
          <span className="text-primary fw-bold text-uppercase tracking-wider small">
            Our Services
          </span>
          <h2 className="display-5 fw-bold mt-2">
            What We Offer
          </h2>
          <p className="lead mx-auto" style={{ maxWidth: '600px' }}>
            A comprehensive financial ecosystem designed to help you fund, invest, and save securely.
          </p>
        </div>
        <Row className="justify-content-center">
          {features.map((feature, index) => (
            <Col md={6} lg={3} key={index} className="mb-4">
              <Card className="h-100 border-0 shadow-sm hover-lift transition-all p-4">
                <Card.Body>
                  <div className="mb-4 p-3 d-inline-block rounded-circle bg-blue-50 text-secondary">
                    {feature.icon}
                  </div>
                  <h4 className="fw-bold mb-3 text-primary">{feature.title}</h4>
                  <Card.Text className="text-muted">
                    {feature.details}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
export default Features;
